import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { CreditCertificateDetail } from 'projects/store/src/app/interfaces';

@Component({
  selector: 'app-closing-report-certificate',
  templateUrl: './closing-report-certificate.component.html',
  styleUrls: ['./closing-report-certificate.component.scss']
})
export class ClosingReportCertificateComponent {
  @Input() detail!: CreditCertificateDetail;
  @Input() isPdf = false;
  @Input() showActions = false;
  @Input() logoSvg: SafeHtml | null = null;
  @Input() isGeneratingPdf = false;
  @Input() isLoadingCertificateDetail = false;

  @Output() close = new EventEmitter<void>();
  @Output() exportPdf = new EventEmitter<void>();

  getStatusSeverityClass(severity: string): string {
    return severity ? `status-tag--${severity}` : '';
  }

  getAllyPaymentMessageClass(severity: string): string {
    return severity ? `certificado-modal__messageBox--${severity}` : '';
  }

  getAllyPaymentIcon(severity: string): string {
    return severity === 'success' ? 'pi pi-check-circle' : 'pi pi-exclamation-circle';
  }

  onClose(): void {
    this.close.emit();
  }

  onExportPdf(): void {
    this.exportPdf.emit();
  }
}
